<template>
<section>
    <div v-if="loading" class="content content-centered">
        <pulse-loader></pulse-loader>
    </div>
    <div v-show="!loading" class="content">
        <div class="box">
            <div class="box-body">
                <div class="row">
                    <div class="flash-message col-md-4 col-md-offset-4 text-center" v-if="flash">
                        <div class="alert" :class="'alert-' + flashType">
                            {{ flashMessage }}
                        </div>
                    </div>
                </div>
                <div id="details" class="row">
                    <vue-form :state="formstate" @submit.prevent="onSubmit" class="row">
                        <div class="col-sm-12">
                            <div class="col-sm-6">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.cityId)">
                                    <label>City</label>
                                    <select required name="cityId" class="form-control" v-model="wasteRecycle.cityId" :disabled="isCityDisable" @change="getCityId($event.target.value)">
                                        <option value="" disabled>Select City Name</option>
                                        <option v-for="city in citys" :value="city._id">{{ city.cityName }}
                                        </option>
                                    </select>
                                    <field-messages name="cityId" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">This is required field</div>
                                    </field-messages>
                                </validate>
                            </div>

                            <div class="col-sm-6">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.wasteCollectionArea)">
                                    <label>Area</label>
                                    <select required name="wasteCollectionArea" class="form-control" v-on:change="getSegregation($event.target.value)" v-model="wasteRecycle.wasteCollectionArea">
                                        <option value="" disabled>Select Area</option>
                                        <option v-for="vehicleId in wasteCollectionAreaPoints" :value="vehicleId.id">{{ vehicleId.name }}</option>
                                    </select>
                                    <field-messages name="wasteCollectionArea" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">This is required field</div>
                                    </field-messages>
                                </validate>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="col-sm-6">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.segregationPlant)">
                                    <label>Segregation Plant</label>
                                    <select disabled required name="segregationPlant" class="form-control" v-model="wasteRecycle.segregationPlant">
                                        <option value="" disabled>Select Segregation Plant</option>
                                        <option v-for="segregationId in segregations" :value="segregationId.id" :key="segregationId.id">
                                            {{ segregationId.name }}
                                        </option>
                                    </select>

                                    <field-messages name="segregationPlant" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">This is required field</div>
                                    </field-messages>
                                </validate>
                            </div>

                            <div class="col-sm-6">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.amount)">
                                    <label>Amount (INR)</label>
                                    <input type="text" name="amount" class="form-control" required v-model="wasteRecycle.amount" placeholder="Amount" pattern="\d{0,10}" />
                                    <field-messages name="amount" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">Amount is a required field</div>
                                        <div slot="pattern">
                                            Numbers are allowed(Max limit 10 digits).
                                        </div>
                                    </field-messages>
                                </validate>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="col-sm-6">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.vendor)">
                                    <label>Vendor</label>
                                    <select required name="vendor" class="form-control" v-model="wasteRecycle.vendor">
                                        <option value="" disabled>Select Vendor</option>
                                        <option v-for="vendorId in vendorPoints" :value="vendorId.id">
                                            {{ vendorId.name }}
                                        </option>
                                    </select>
                                    <field-messages name="vendor" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">This is required field</div>
                                    </field-messages>
                                </validate>
                            </div>

                            <div class="col-sm-6">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.memo)">
                                    <label>Memo</label>
                                    <textarea name="memo" maxlength="200" class="form-control" required v-model="wasteRecycle.memo" placeholder="memo" pattern="[\w\W]{1,200}" />
                                    <field-messages
                      name="memo"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required">Memo is a required field</div>
                      <div slot="pattern">
                        Alphabets/Numbers are allowed.
                      </div>
                    </field-messages>
                  </validate>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="col-sm-6">
                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.memoPicture)"
                  >
                    <label>Memo Picture</label>
                    <input
                      type="file"
                      id="fileName"
                      accept="image/png,image/jpeg,image/jpg,application/pdf"
                      name="memoPicture"
                      class="form-control"
                      required
                      @change="onDocumentchanged"
                    />
                    <field-messages
                      name="memoPicture"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required">
                        Please upload less than 5mb Memo Picture
                      </div>
                    </field-messages>
                    <div
                      class="border p-2 mt-3"
                      v-if="
                        $route.params &&
                          $route.params._id != '0' &&
                          wasteRecycle.memoPicture
                      "
                    >
                      <a v-bind:href="wasteRecycle.memoPicture" target="_blank">
                        View
                      </a>
                    </div>
                  </validate>
                </div>

                <div class="col-sm-6">
                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.contactNumber)"
                  >
                    <label>Contact Number</label>
                    <input
                      maxlength="10"
                      required
                      v-model="wasteRecycle.contactNumber"
                      type="string"
                      class="form-control"
                      name="contactNumber"
                      placeholder="Contact"
                      pattern="[78965][0-9]{9}"
                    />
                    <field-messages
                      name="contactNumber"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required">This is required field</div>
                      <div slot="pattern">Contact Number is invalid</div>
                    </field-messages>
                  </validate>
                </div>
              </div>
            </vue-form>

            <div class="col-sm-12 text-right">
              <router-link :to="{ name: 'wasteRecycle' }">
                <button class="mr-5 btn btn-default" type="button">
                  Cancel
                </button>
              </router-link>
              <button
                class="mr-2 btn gradientbt"
                type="submit"
                @click="createWasteRecycle"
                :disabled="!(formstate.$dirty && formstate.$valid && this.docs)"
                v-if="$route.params && $route.params._id == '0'"
              >
                Save
              </button>
              <button
                class="btn gradientbt mr-5"
                type="submit"
                @click="updateWasteRecycle"
                :disabled="
                  !((formstate.$dirty || isFileChange) && formstate.$valid)
                "
                v-if="$route.params && $route.params._id != '0'"
              >
                Update
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import store from "../../../store";
import {
    formService,
    eventBus,
    wasterecycleService,
    fileService,
} from "../../../services";
import {
    EVENTS
} from "../../../config";
import {
    USER_ROLES
} from "../../../config";
import {
    mapState
} from "vuex";

export default {
    name: "wasteRecycleCreate",
    changedFlag: "",
    data() {
        return {
            isCityDisable: false,
            isFileChange: false,
            ready: false,
            USER_ROLES: USER_ROLES,
            loading: false,
            flash: false,
            flashType: null,
            flashMessage: "",
            EVENTS: EVENTS,
            formstate: {},
            wasteRecycle: {
                cityId: "",
                wasteCollectionArea: "",
                segregationPlant: "",
                vendor: "",
            },
            oldWasteRecycle: {},
            wasteRecycleId: [],
            data: {},

            wasteCollectionAreaPoints: {},
            vendorPoints: {},
            segregations: [],
            docs: null,
            citys: {},
        };
    },
    mounted: function () {
        this.getCityList();
    },

    methods: {
        fieldClassName: formService.fieldClassName,

        getCityList() {
            if (this.$store.state.auth.user.role.key === "cityAdmin") {
                const {
                    _id,
                    cityName
                } = this.$store.state.auth.user.cityId;
                this.citys = [{
                    _id: _id,
                    cityName: cityName,
                }, ];
                this.wasteRecycle["cityId"] = _id;
                this.isCityDisable = true;
                this.getCityId(_id);
                return;
            }
            this.loading = true;
            const params = {};
            let cityList = [];
            // params.page = 1;
            // params.limit = 999;
            this.$cityRepository
                .collectionCitysList(params)
                .then((res) => {
                    this.loading = false;
                    let citysList = res.data.response;
                    citysList.sort((item1, item2) => {
                        return item1.cityName.toLowerCase() < item2.cityName.toLowerCase() ?
                            -1 :
                            1;
                    });
                    this.citys = citysList;
                })
                .catch((error) => {
                    this.loading = false;
                    console.error("citys.requestFunction-error:", error);
                    this.$snotify.error("Get citys list failed", "Error!");
                });
        },

        getWasteCollectionAreaPointsList(cityId) {
            this.loading = true;
            let wastecollectionareaList = [];
            return wasterecycleService
                .getWasteCollectionAreaList(cityId)
                .then((res) => {
                    this.loading = false;
                    res.data.response.forEach((element) => {
                        if (element.status == true && element.cityId === cityId) {
                            wastecollectionareaList.push({
                                name: element.areaName,
                                id: element._id,
                            });
                        }
                    });
                    wastecollectionareaList.sort((item1, item2) => {
                        return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
                    });
                    this.wasteCollectionAreaPoints = wastecollectionareaList;
                })
                .catch((error) => {
                    this.loading = false;
                    console.error(
                        "waste Collection Area Points.requestFunction-error:",
                        error
                    );
                    this.$snotify.error(
                        "Get Waste Collection Area Points list failed",
                        "Error!"
                    );
                });
        },

        getVendorPointList(cityId) {
            this.loading = true;
            const params = {};
            params.$select = ["_id", "vdName"];
            params.status = true;
            params.cityId = cityId;
            let vendorList = [];
            // delete params.isDeleted;
            this.$vendorDataListRepository
                .list(params)
                .then((res) => {
                    this.loading = false;
                    res.data.docs.forEach((element) => {
                        vendorList.push({
                            name: element.vdName,
                            id: element._id,
                        });
                    });
                    vendorList.sort((item1, item2) => {
                        return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
                    });
                    this.vendorPoints = vendorList;
                })
                .catch((error) => {
                    this.loading = false;
                    console.error("Vendor Point List.requestFunction-error:", error);
                    this.$snotify.error("Get Vendor Point list failed", "Error!");
                });
        },

        getWasteRecycle() {
            const params = {};
            let wasteRecyclea = [];
            return wasterecycleService
                .getById(this.$route.params._id, params)
                .then((response) => {
                    this.getCityId(response.data.response.cityId._id);

                    wasteRecyclea = response.data.response;
                    wasteRecyclea["segregationPlant"] =
                        response.data.response.segregationPlant._id;
                    wasteRecyclea["vendor"] = response.data.response.vendor._id;
                    wasteRecyclea["cityName"] = response.data.response.cityId.cityName;
                    wasteRecyclea["cityId"] = response.data.response.cityId._id;
                    this.getSegregation(response.data.response.wasteCollectionArea);
                    this.wasteRecycle = wasteRecyclea;

                    this.oldWasteRecycle = _.cloneDeep(this.wasteRecycle);
                })
                .catch((error) => {
                    console.error("Waste recycle-error:", error);
                    this.$snotify.error("Get Waste Recycle failed", "Error!");
                });
        },

        getSegregation(value) {
            let segregation = {};
            return wasterecycleService
                .getwasteCollection(value)
                .then((response) => {
                    segregation["name"] = response.data.response.segregationId.plantName;
                    segregation["id"] = response.data.response.segregationId._id;
                    this.segregations.splice(0);
                    this.segregations.push(segregation);
                    this.wasteRecycle.segregationPlant =
                        response.data.response.segregationId._id;
                    this.$store.dispatch(
                        "setBreadcrumbTitle",
                        response.data.response.areaName
                    );
                })
                .catch((error) => {
                    console.error("Waste recycle-error:", error);
                    this.$snotify.error("Get Waste Recycle failed", "Error!");
                });
        },

        onDocumentchanged(event) {
            const fileName = document.getElementById("fileName");
            if (
                ["image/png", "image/jpeg", "image/jpg", "application/pdf"].includes(
                    event.target.files[0]["type"]
                )
            ) {
                if (event.target.files[0].size > 1024 * 1024 * 5) {
                    this.$snotify.error("File Size max limit of 5 MB", "Error!");
                    fileName.value = "";
                    event.preventDefault();
                    return;
                } else {
                    this.docs = event.target.files[0];
                    if (this.docs) {
                        this.isFileChange = true;
                    } else {
                        this.isFileChange = false;
                    }
                    if (this.$route.params && this.$route.params._id != '0') {
                        this.changedFlag = true;
                    }
                }
            } else {
                this.$snotify.error("Upload .png, .jpeg, .jpg, .pdf files", "Error!");
                fileName.value = "";
            }
        },
        async uploadDocument() {
            let docsArr = [];
            docsArr.push(this.docs);
            const response = await fileService.fileUpload(docsArr, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            return response.data;
        },

        async createWasteRecycle() {
            this.loading = true;
            // if (this.docs != null) {
            let uploadedFileLocation = await this.uploadDocument();
            if (uploadedFileLocation !== "") {
                this.wasteRecycle.memoPicture = uploadedFileLocation[0].Location;
            }
            // }

            return wasterecycleService
                .addWasteRecycle(this.wasteRecycle)
                .then((response) => {
                    this.loading = false;
                    this.flash = false;
                    this.$snotify.success(
                        `The Waste Recycle has been added successfully.`
                    );
                    this.$router.push("/wasteRecycle");
                })
                .catch((error) => {
                    this.loading = false;
                    this.$snotify.error(error.data.message, "Error !");
                });
        },

        clearChanges() {
            this.wasteRecycle = _.cloneDeep(this.oldWasteRecycle);
            this.formstate._reset();
        },
        async updateWasteRecycle() {
            const id = this.$route.params._id;
            this.loading = true;
            this.data = {};
            this.data["cityId"] = this.wasteRecycle["cityId"];
            this.data["wasteCollectionArea"] = this.wasteRecycle[
                "wasteCollectionArea"
            ];
            this.data["segregationPlant"] = this.wasteRecycle["segregationPlant"];
            this.data["disel"] = this.wasteRecycle["disel"];
            this.data["amount"] = this.wasteRecycle["amount"];
            this.data["vendor"] = this.wasteRecycle["vendor"];
            this.data["memo"] = this.wasteRecycle["memo"];
            // this.data["memoPicture"] = this.wasteRecycle["memoPicture"];
            this.data["contactNumber"] = this.wasteRecycle["contactNumber"];
            this.data["_id"] = this.$route.params._id;

            if (this.docs != null) {
                let uploadedFileLocation = await this.uploadDocument();
                if (uploadedFileLocation !== "") {
                    this.data["memoPicture"] = uploadedFileLocation[0].Location;
                }
            } else {
                this.data["memoPicture"] = this.wasteRecycle["memoPicture"];
            }

            return wasterecycleService
                .updateWasteRecycle(id, this.data)
                .then((response) => {
                    this.loading = false;
                    this.flash = false;
                    this.formstate._reset();
                    this.oldWasteRecycle = _.cloneDeep(this.wasteRecycle);
                    this.$snotify.success(
                        `The Waste Recycle has been updated successfully.`
                    );
                    this.$router.push("/wasteRecycle");
                })
                .catch((error) => {
                    this.loading = false;
                    console.error("Waste Recycle.Update-error:", error);
                    this.$snotify.error("Update Waste Recycle failed", "Error!");
                    if (error.data.message.includes("must be one of")) {
                        this.flash = true;
                        this.flashType = "error";
                        this.flashMessage =
                            "That wasteRecycle name is not allowed. You must first update the list of allowed wasteRecycle names" +
                            " in the appy client and server config.";
                    }
                });
        },
        getCityId(cityId) {
            this.wasteRecycle.segregationPlant = "";
            this.wasteRecycle.wasteCollectionArea = "";
            this.wasteRecycle.vendor = "";
            this.getVendorPointList(cityId);
            this.getWasteCollectionAreaPointsList(cityId);
        },
    },
    created() {
        const promises = [];
        this.loading = true;

        if (this.$route.params && this.$route.params._id && this.$route.params._id != '0') {
            promises.push(this.getWasteRecycle());
        }
        Promise.all(promises)
            .then(() => {
                this.loading = false;
                this.ready = true;
            })
            .catch(() => {
                this.loading = false;
            });
    },
    beforeDestroy() {},

    // fieldClassName: function (field) {
    //     if (!field) {
    //         return "";
    //     }
    //     if ((field.$touched || field.$submitted) && field.$valid) {
    //         return "has-success";
    //     }
    //     if ((field.$touched || field.$submitted) && field.$invalid) {
    //         return "has-danger";
    //     }
    // },
};
</script>

<style scoped>
.required-field>label::after {
    content: "*";
    color: red;
    margin-left: 0.25rem;
}

.form-control-feedback {
    font-weight: 100;
    color: red;
    position: initial;
    text-align: left;
    height: auto;
    width: auto;
}

.has-danger {
    color: red;
}

.mt {
    margin-top: 7px;
}

.gradientbt {
    background: #0f6940;
    color: white;
}

.inputwrapper {
    position: relative;
}

.maps {
    position: absolute;
    top: 7px;
    right: 10px;
}
</style>



// WEBPACK FOOTER //
// wasteRecycleCreate.vue?bd17cfee